<template>
  <b-overlay
    :show="loading"
    rounded="lg"
    spinner-variant="customer"
    class="min-vh-100"
  >
    <div class="intro-header min-vh-100">
      <b-row
        no-gutters
        class="min-vh-100"
        :style="{
          backgroundSize: 'cover',
          backgroundImage: 'url(' + background + ')',
        }"
      >
        <b-col
          lg="7"
          class="image-background image-login"
          order="0"
          order-lg="1"
          style
        >
        </b-col>
        <b-col lg="5" :style="{ background: color }" order="1" order-lg="0">
          <div style="height: 100%" class="d-flex flex-wrap">
            <div class="w-100 m-5 d-none d-lg-block">
              <b-link :href="$store.state.customer_link" class="mt-5 p-2 ml-4">
                <img
                  class="mt-3"
                  :src="logo"
                  v-if="logo"
                  style="width: 300px"
                />
              </b-link>
            </div>
            <div class="d-flex align-content-center flex-wrap w-100">
              <b-row>
                <b-col>
                  <b-link
                    :href="$store.state.customer_link"
                    class="mt-5 p-2 ml-4 d-lg-none pb-5"
                  >
                    <img
                      class="mt-3 mb-5"
                      :src="logo"
                      v-if="logo"
                      style="width: 100%; max-width: 300px"
                    />
                  </b-link>
                  <h1 class="text-center text-white login-text">
                    {{ loginText }}
                  </h1>
                  <div class="px-5 mx-5 my-5">
                    <b-alert
                      class="template-radius"
                      variant="danger"
                      :show="error.length > 0"
                      dismissible
                      >{{ error }}</b-alert
                    >
                    <label class="text-white" v-if="chilean && !isDni"
                      >RUT
                      <small
                        >Por favor ingresar sin puntos y con guión</small
                      ></label
                    >
                    <label class="text-white" v-else
                      >DNI
                      <small style="visibility: hidden"
                        >xxx xxxxx xxxxxxxx xxx xxxxx x xxx xxxxx</small
                      ></label
                    >
                    <input
                      id="rut"
                      v-if="chilean && !isDni"
                      @keyup="formatRut"
                      v-model="rut"
                      placeholder="Ingrese RUT"
                      class="form-control template-radius"
                    />
                    <input
                      v-else
                      v-model="rut"
                      placeholder="Ingrese DNI"
                      class="form-control template-radius"
                    />
                    <label
                      class="text-white"
                      style="padding-top: 10px"
                      v-if="chilean"
                      ><input type="checkbox" v-model="isDni" /> No posee
                      RUT</label
                    ><br />
                    <label class="text-white mt-3">Contraseña</label>
                    <input
                      placeholder="Ingrese contraseña"
                      id="password"
                      class="form-control template-radius"
                      :type="passwordFieldType"
                      @input="password = $event.target.value"
                      autocomplete="off"
                    />
                    <br />
                    <b-button
                      variant="login"
                      block
                      class="mt-3 template-radius"
                      @click="login()"
                      >ENTRAR</b-button
                    >
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-overlay>
</template>
<script>
export default {
  name: "login",
  components: {},
  data() {
    return {
      color: "rgba(22,22,22,.4)",
      image: "",
      rut: "",
      isDni: false,
      error: "",
      password: "",
      loading: false,
      chilean: null,
      passwordFieldType: "password",
    };
  },
  mounted() {
    //this.get_info_customer()
  },
  methods: {
    login() {
      let app = this;
      app.loading = true;
      app.error = "";
      app.$auth.login({
        data: {
          email: this.rut,
          password: this.password,
          customer_id: this.customerId,
          error: null,
        },
        success: function (msg) {
          app.loading = false;
          app.error = "";
          app.$auth.user(msg.data.user);
        },
        error: function () {
          app.loading = false;
          this.error = this.chilean
            ? "RUT y/o Contraseña inválidos"
            : "DNI y/o Contraseña inválidos";
        },
        rememberMe: true,
        redirect: `/app/${this.customer}`,
        fetchUser: true,
      });
    },
    goTo(link, data = null) {
      this.$router.push({ name: link, params: data });
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    digito(rut, dv) {
      let suma = 0;
      let multiplicador = 2;
      while (rut !== 0) {
        if (multiplicador === 8) {
          multiplicador = 2;
        }
        suma += (rut % 10) * multiplicador;
        rut = Math.trunc(rut / 10);
        multiplicador++;
      }
      suma = 11 - (suma % 11);
      switch (suma) {
        case 11:
          return "0" === dv;
        case 10:
          return "K" === dv.toUpperCase();
        default:
          return suma.toString() === dv;
      }
    },
    formatRut() {
      if (this.chilean && !this.isDni) {
        if (this.rut.length > 0) {
          this.rut = this.rut.replace(/[^\dKk]/g, "");
          let dato = this.rut;
          let largo = dato.length;
          if (largo === 1) {
            this.dv = dato;
            this.rut = "";
            this.digito(this.rut, this.dv);
            this.formato();
          } else if (largo > 1) {
            this.dv = dato.substring(largo - 1);
            this.rut = dato.substring(largo - 1, 0);
            this.digito(this.rut, this.dv);
            this.formato();
          }
        }
      } else {
        return true;
      }
    },
    formato() {
      let rut = this.rut ? parseInt(this.rut) + "-" : "";
      this.rut = rut + this.dv;
    },
  },
  computed: {
    logo() {
      if (this.$store.getters.getCustomerData) {
        return this.$store.getters.getCustomerData.show_logo_login
          ? this.$store.getters.getCustomerData.logo_1_url
          : null;
      }
      return null;
    },
    loginText() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.salute_login
        : "";
    },
    background() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.login_background
        : null;
    },
    customer() {
      return this.$store.getters.getCustomer;
    },
    customerId() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.customer_id
        : null;
    },
    country() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.country
        : 1;
    },
  },
  watch: {
    country: {
      handler: function () {
        this.chilean = this.country == 0 ? false : true;
      },
      immediate: true,
    },
  },
};
</script>
<style>
#overlay-login {
  height: 100vh;
}
.container-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.content-login {
  width: auto;
  height: auto;
}
.content-login .btn {
  width: 100%;
}
.login-text {
  text-transform: uppercase;
}
.login-logo {
  top: 1.6em;
  width: 10em;
}
.text-white {
  color: white !important;
}
.intro-header {
  /* clip: rect(0, auto, auto, 0); */
  position: absolute;
  width: 100%;
  min-height: 100vh;
}
video#bgvid {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -1;
  -ms-transform: translateX(-50%) translateY(-50%);
  -moz-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  background-size: cover;
}
audio,
canvas,
progress,
video {
  display: inline-block;
  vertical-align: baseline;
}
</style>
